import { Dropdown, Menu } from 'antd';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ExclamationCircleOutlined } from '@ant-design/icons';

import { Thinning } from '../interfaces';
import Icon from '../../../common/components/Icon/Icon';
import { commonOptions } from '../../../config/commons';
import * as optimalHarvestPointSlice from '../optimalHarvestPointSlice';
import { lrvConfirm } from '../../../common/components/LrvConfirm/LrvConfirm';
import { ExtraActionsButton } from '../../../common/components/buttons/ExtraActionsButton';

import styles from './DropdownThinningOptions.module.scss';

interface Props {
  theme?: 'light' | 'dark';
  thinning: Thinning
}

export const DropdownThinningOptions = (props: Props) => {
  const { theme = 'light', thinning } = props;

  const [t] = useTranslation();
  const dispatch = useDispatch();

  const renderConfirmationInactiveThinning = () => {
    const title = t('thinnings.confirm.title');
    const description = t('thinnings.confirm.description');
    const idOkButton = 'confirm_button';
    const idCancelButton = 'cancel_button';

    lrvConfirm({
      theme: 'light',
      title: title,
      content: description,
      icon: <ExclamationCircleOutlined />,
      okText: t('thinnings.confirm.yes').toUpperCase(),
      cancelText: t('thinnings.confirm.no').toUpperCase(),
      okButtonProps: { id: idOkButton },
      cancelButtonProps: { id: idCancelButton },
      onOk () {
        if (!thinning?._id) {
          return;
        }

        dispatch(optimalHarvestPointSlice.inactiveThinning({ thinningId: thinning._id, companyId: thinning.companyId, stockingId: thinning.stockingId, active: false }));
      },
    });
  };

  const menuItemsOptions = (thinning: Thinning) => {
    return (
      <Menu
        onClick={({ key, domEvent }) => {
          domEvent.stopPropagation();

          switch (key) {
            case commonOptions.EDIT: {
              if (!thinning?._id) {
                return;
              }
              
              dispatch(optimalHarvestPointSlice.setShowEditThinningModal(true));
              dispatch(optimalHarvestPointSlice.fetchThinning({ thinningId: thinning._id }));
              return;
            }

            case commonOptions.REMOVE: {
              renderConfirmationInactiveThinning();
              return;
            }
          }
        }}
      >
        <Menu.Item id='edit' key={commonOptions.EDIT} className={styles.menuItemOptions}>
          <Icon name='edit' theme={theme} />&nbsp;
          <span>{t('thinnings.edit')}</span>
        </Menu.Item>

        <Menu.Item id='remove' key={commonOptions.REMOVE} className={styles.menuItemOptions}>
          <Icon name='delete-bin' theme={theme} />&nbsp;
          <span>{t('thinnings.remove')}</span>
        </Menu.Item>
      </Menu>
    );
  };

  return (
    <div className={styles.container}>
      <Dropdown
        className={styles.dropdown}
        overlay={menuItemsOptions(thinning)}
        trigger={['click']}
        getPopupContainer={() => document.body}
      >
        <ExtraActionsButton
          className={styles.icon}
          onClick={(e) => e.stopPropagation()}
        />
      </Dropdown>
    </div>
  );
};
